import { render, staticRenderFns } from "./BaseVerticalDivider.vue?vue&type=template&id=767dab28&"
import script from "./BaseVerticalDivider.vue?vue&type=script&lang=js&"
export * from "./BaseVerticalDivider.vue?vue&type=script&lang=js&"
import style0 from "./BaseVerticalDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports